import { render } from "./NextSteps.vue?vue&type=template&id=4b77870a&scoped=true"
import script from "./NextSteps.vue?vue&type=script&lang=js"
export * from "./NextSteps.vue?vue&type=script&lang=js"

import "./NextSteps.vue?vue&type=style&index=0&id=4b77870a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b77870a"]])

export default __exports__